import { TableBodyProps, TableBody as MuiTableBody, TableRow, TableCell } from "@mui/material";
import React from "react";
type CustomTableBodyProps = {
  emptyMessage?: string;
} & TableBodyProps;
export function TableBody({ emptyMessage = "No records available", children, ...others }: CustomTableBodyProps) {
  return (
    <MuiTableBody {...others}>
      {React.Children.count(children) > 0 ? (
        children
      ) : (
        <TableRow>
          <TableCell colSpan={44}>{emptyMessage}</TableCell>
        </TableRow>
      )}
    </MuiTableBody>
  );
}
